import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import s from 'components/bolt/header/headerExpanded.sss';
import Store from 'store/store';

import { getRelativePageUrl} from 'utils/bolt';
import { filterUnusedPages } from 'utils/bolt/header';
import { sortObjectByOrder, accessNested, joinClasses } from 'utils/utils';

import HTML from 'components/core/html/html';
import Link from 'components/bolt/link/link';

import { getDynamicData } from 'utils/bolt/dynamicData';

export default class HeaderExpanded extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount?.();
		if (this.props.appData?.options?.cmsManaged) {
			this.loadCustomData();
		}
	}

	async loadCustomData() {
		let dynamicData = await getDynamicData('landing');
		if (!dynamicData) return;

		let dynamicItems =
		dynamicData.nav?.items
			?.filter(item => item.enabled !== false)
			.map(item => ({
				name: item.label,
				path: item.link,
				linkType: 'primary'
			})) || [];

		dynamicItems = dynamicItems.map(item => {
			if (item.path === 'belowTheLine') item.linkType = 'secondary';
			if (item.path === 'composersInitiative') item.linkType = 'secondary';
			return item;
		});

		const slugMap = {
			filmmakersStrategies: 'filmmakers-strategies',
			composersInitiative: 'composers-initiative',
			utd: 'utd',
			belowTheLine: 'below-the-line',
			events: 'events'
		};

		const filtered = [];
		for (const item of dynamicItems) {
			const slug = slugMap[item.path];

			if (!slug) {
				filtered.push(item);
				continue;
			}

			const pageData = await getDynamicData(slug);

			if (!pageData || pageData.pageEnabled !== false) {
				filtered.push(item);
			}
		}

		// filtered.push({
		// 	name: 'GreenerLight',
		// 	path: 'https://www.nbcuniversalgreenerlight.com/',
		// 	linkType: 'primary'
		// });

		this.standardLinks = filtered;
		this.forceUpdate();
	}

	trackNavLink(linkName, id) {
		Store.emit('CUSTOM_EVENT', {
			category: 'burgerMenu',
			action: 'burger-menu-click',
			label: linkName
		});
	}

	updateLinks(props = this.props) {
		this.navItems = sortObjectByOrder(accessNested(props, 'appData.header.powsterHeader.nav'));
		this.filteredNavItems = filterUnusedPages(props, this.navItems);
		this.standardLinks = this.filteredNavItems.filter(item => item );
		this.featuredLinks = [];
	}

	renderLink(element, isFeatured) {
		// const isInternalLink = /^bolt/.test(element.path);
		let [pageIdRaw, hash] = element.path?.split('#') || [];
		let [pageId, queryStringRaw] = pageIdRaw?.split('?') || [];
		let queryString = element.queryString || (queryStringRaw ? `?${queryStringRaw}` : '');

		const page = accessNested(this.props, ['appData', 'pages', pageId]);
		const calendarEnabled = !!accessNested(this.props, 'appData.header.powsterHeader.calendars', null);
		const isInternalLink = !!page || element.path?.startsWith('@');
		const sizing = this.getLinkSizing(!isInternalLink);

		const activePage = this.props.activePage || 'boltHome';
		const activeSection = this.props.headerData.activeSection || 'boltHome';
		let active = activePage === pageId || (activePage === 'boltHome' && activeSection === element.path);
		const baseCopy = accessNested(this.props, 'appData.copy.baseCopy', {});
		let content = baseCopy[element.name] || element.name || element.id;

		// - start  - groupBookings same page 2 header items active 'hack'
		const groupBookingsEnabled = accessNested(this.props, 'appData.pages.boltShowtimes.data.groupBookings.isEnabled', false);
		if (groupBookingsEnabled && activePage == pageId && element.path === 'boltShowtimes' && queryString === '?groupbookings') {
			active = Store.get().groupBookingsShowtimes === true;
		}
		if (groupBookingsEnabled && activePage == pageId && element.path === 'boltShowtimes' && queryString === '?booknow') {
			active = Store.get().groupBookingsShowtimes === false;
		}
		//- end -

		if (page?.ageRestricted && this.props.client?.ofAge === false) {
			return;
		}

		if (element.path === 'boltShowtimes' && this.props.isCalendarRemindMode) {
			if (!calendarEnabled) return;
			content = baseCopy.$MENU_CALENDAR_REMINDER || 'Reminder';
		}

		let attributes = {};
		if (!element.disabled) {
			if (!isInternalLink) {
				attributes.href = element.path;
				attributes.target = element.sameWindow ? '_self' : '_blank';
				attributes.rel = 'noopener noreferrer';
				attributes.onClick = () => this.trackNavLink(content);
			} else {
				attributes.href = getRelativePageUrl(pageId, queryString, hash) || '#';
				attributes.onClick = element.onClick || (e => this.closeAndNavigate(pageId + (hash ? `#${hash}` : ''), e, content, queryString));
			}
		} else {
			attributes['aria-disabled'] = true;
		}

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');
		//const font = isFeatured ? fontStyles.navSecondaryLink : fontStyles.navPrimaryLink;

		return (
			<Link
				key={element.id || element.link || element.name}
				class={joinClasses(s.link, active && s.active, s[element.linkType])}
				{...attributes}
			>
				<HTML class={s.content} content={content} markdown />
				<HTML class={s.hidden} content={content} aria-hidden markdown />
			</Link>
		);
	}
}

